import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { Component } from '@angular/core'
import { ModalController } from '@ionic/angular/standalone'
import { PlatformService } from '../services/business/platform.service'
import { Utils } from '../utils/utils'
import { TelemetryService } from '../../security/services/telemetry'

@Component({
    selector: 'app-html-content-modal',
    templateUrl: './html-content-modal.component.html',
    styleUrls: ['./html-content-modal.component.scss'],
})
export class HtmlContentModalComponent {
    public modalHtmlUrl = ''
    public showCloseButton = true
    public safeResourceUrl: SafeResourceUrl

    constructor(public platform: PlatformService,
        public modalController: ModalController,
        public sanitizer: DomSanitizer,
        private telemetry: TelemetryService) {
        setTimeout(() => {
            this.safeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Utils.buildEmbeddedContentUrl(this.modalHtmlUrl))
            this.telemetry.event('modal.open', { targetHost: this.targetHost, viewer: this.viewer })
        }, 100)
    }

    public onFrameLoad(): void {
        this.telemetry.event('modal.iframe_load', { targetHost: this.targetHost, viewer: this.viewer })
    }

    private get viewer(): string {
        return Utils.isDocumentUrl(this.modalHtmlUrl) ? 'google-drive' : 'direct'
    }

    private get targetHost(): string {
        try {
            return new URL(this.modalHtmlUrl, window.location.origin).host
        } catch {
            return 'invalid-url'
        }
    }

    public async dismiss(): Promise<void> {
        const modal = await this.modalController.getTop()
        if (modal) {
            await modal.dismiss()
        }
    }
}
